export enum AccordionStatusType {
	Open = 0,
	Closed = 1
}